/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
} from 'prop-types';
import Media from 'react-media';
import { withRouter, useHistory } from 'react-router-dom';
import { compose } from 'recompose';
import { connect, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import MobileProductFacetsV3 from './MobileProductFacetsV3';
import { getFeatureFlag, getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useCheckedFacets from '../../../../../helpers/hooks/useCheckedFacets';
import { FilterDialog } from '../FilterDialog/FilterDialog';
import useSSRMediaQuery from '../../../../../helpers/hooks/useSSRMediaQuery';

const MobileDesktopFacetsV3 = ({
    isFoodBrand,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    filterFlag,
    category,
    trackEventAction,
    categoryData,
    abCategorySortAndFilter,
    isFacetFiltersEnabled,
    featureFlags,
    setFacetsDataInCollection,
    setFilterDataInCategoryBuilder,
    presentation_family,
    openFacetDropdown,
    productCount,
    filterOn,
}) => {
    const history = useHistory();
    const checkedFacetsData = useCheckedFacets();
    const [checkedOptions, setCheckedOptions] = useState(checkedFacetsData);
    const searchValue = unescape(history.location?.search);
    useEffect(() => {
        setCheckedOptions(checkedFacetsData);
        setFacetsDataInCollection(checkedFacetsData);
    }, [searchValue]);

    const device = useSSRMediaQuery();
    const resetChecked = () => {
        setCheckedOptions([]);
        setFacetsDataInCollection([]);
    };
    const isAggregatorFacetErrorResolver = useSelector(getFeatureFlag('is-facet-throwing-error-resolver-enabled'));
    const timerId = useRef(null);

    const yieldToMain = () => {
        // Use scheduler.yield if it exists:
        if (typeof window !== 'undefined' && 'scheduler' in window && 'yield' in window.scheduler) {
            return window.scheduler.yield();
        }

        // Fall back to setTimeout:
        return new Promise((resolve) => setTimeout(resolve, 0));
    };

    const historyReplace = async (searchParam) => {
        history.replace({
            search: searchParam,
            state: checkedOptions,
        });
        await yieldToMain();
    };

    useEffect(() => {
        let delimiter = '&';
        if (isAggregatorFacetErrorResolver) {
            delimiter = '&facet=';
        }
        const urlSelectedParams = checkedOptions.join(delimiter);
        clearTimeout(timerId.current);
        timerId.current = setTimeout(() => { // delay the history for two ms
            let searchParam = '';
            if (urlSelectedParams) {
                searchParam = `facet=${urlSelectedParams}`;
            } else if (searchValue && !searchValue.includes('facet')) {
                searchParam = searchValue;
            }

            historyReplace(searchParam); // for scheduler yield
        }, 200);
    }, [checkedOptions?.length]);

    // filter sorting dialog
    const filterDialogData = () => category !== null && abCategorySortAndFilter !== 'hide' && (
        <FilterDialog
            cmsFilterFlag={categoryData?.content?.entries?.[0]?.show_filters}
            isFacetFiltersEnabled={isFacetFiltersEnabled}
            filterFlag={filterFlag}
            track={trackEventAction}
            featureFlags={featureFlags}
            setFacetsOptions={setFacetsDataInCollection}
            setFilterOptions={setFilterDataInCategoryBuilder}
            presentation_family={presentation_family}
            brand={categoryData?.brand}
            productFacets={productFacetsBase}
            category={category}
        />
    );
    const filterSvg = (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.637502 1.50451C0.733086 1.2985 0.939547 1.16669 1.16665 1.16669H12.8333C13.0604 1.16669 13.2669 1.2985 13.3625 1.50451C13.4581 1.71052 13.4254 1.95328 13.2787 2.12669L8.74999 7.48194V12.25C8.74999 12.4522 8.64531 12.6399 8.47333 12.7462C8.30135 12.8525 8.08661 12.8622 7.90578 12.7718L5.57245 11.6051C5.37482 11.5063 5.24999 11.3043 5.24999 11.0834V7.48194L0.721238 2.12669C0.57459 1.95328 0.541918 1.71052 0.637502 1.50451ZM2.42391 2.33335L6.27874 6.89168C6.36779 6.99699 6.41665 7.13044 6.41665 7.26835V10.7228L7.58332 11.3062V7.26835C7.58332 7.13044 7.63218 6.99699 7.72124 6.89168L11.5761 2.33335H2.42391Z" fill="#2F363D" />
        </svg>
    );
    // use for Filter SVG icon
    const svgIconData = (classFilter, toggleFilterData, selectedFilters = null) => (
        toggleFilterData ? (
            <>
                <span>Hide Filters </span>
                <CloseIcon className={classFilter.hideFilters} />
            </>
        ) : (
            <>
                <span>Filter{selectedFilters ? ` (${selectedFilters})` : ''}</span>
                {filterSvg}
            </>
        )
    );
    return (
        <Media query={{ maxWidth: 1024 }} defaultMatches={device !== 'desktop'}>
            {(smallScreens) => (smallScreens
                       && (
                           <MobileProductFacetsV3
                               isFoodBrand={isFoodBrand}
                               productFacetsBase={productFacetsBase}
                               isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                               category={category}
                               trackEventAction={trackEventAction}
                               categoryData={categoryData}
                               setFacetsDataInCollection={setFacetsDataInCollection}
                               svgIconData={svgIconData}
                               filterDialogData={filterDialogData}
                               abCategorySortAndFilter={abCategorySortAndFilter}
                               presentation_family={presentation_family}
                               setFilterDataInCategoryBuilder={setFilterDataInCategoryBuilder}
                               openDisplayFacets
                               openFacetDropdown={openFacetDropdown}
                               checkedOptions={checkedOptions}
                               setCheckedOptions={setCheckedOptions}
                               resetChecked={resetChecked}
                               productCount={productCount}
                               isFacetFiltersEnabled={isFacetFiltersEnabled}
                               filterOn={filterOn}
                           />
                       ))}
        </Media>
    );
};

MobileDesktopFacetsV3.propTypes = {
    // classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    filterFlag: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    categoryData: object.isRequired,
    abCategorySortAndFilter: object.isRequired,
    isFacetFiltersEnabled: bool.isRequired,
    featureFlags: object.isRequired,
    setFacetsDataInCollection: func.isRequired,
    setFilterDataInCategoryBuilder: func.isRequired,
    presentation_family: string.isRequired,
    openFacetDropdown: string.isRequired,
    productCount: number,
    filterOn: string,
};

MobileDesktopFacetsV3.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    productCount: 0,
    filterOn: 'Category',
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withRouter,
    connect(mapStateToProps, null),
);

export default enhance(MobileDesktopFacetsV3);
